"use client";
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Manufacturing expertise",
    "Proven track record",
    "Comprehensive, end-to-end service",
    "Security & compliance",
    "Scalable, custom solution",

  ];

  const tabContent = [
    {
      heading: "Manufacturing expertise",
      subheading: "We understand the manufacturing industry’s unique challenges and bring solutions that improve efficiency, reliability, and quality control for sustainable growth.",
      image: cl1Tab,
    },
    {
      heading: "Proven track record",
      subheading: " Our analytics solutions deliver measurable results, from cost reduction and increased yield to improved machine uptime and quality consistency. ",
      image: cl2Tab,
    },
    {
      heading: "Comprehensive, end-to-end service",
      subheading: " We provide full-service analytics, from data integration to insight generation and implementation, ensuring your manufacturing operation benefits at every stage.",
      image: cl3Tab,
    },
    {
      heading: "Security & compliance",
      subheading: "We prioritize data security and industry compliance, giving you the peace of mind that your production data is protected and meets regulatory standards.",
      image: cl4Tab,
    },
    {
      heading: "Scalable, custom solution",
      subheading: "Our analytics solutions are designed to adapt to your changing needs, providing value that grows with your operation as you scale and expand.",
      image: cl4Tab,
    },

  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}

          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${index === activeTab ? "active" : ""
            }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>

          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
              <Image
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].heading}
                width={457}
                height={257}
                className="productbanner_imageslider"
                loading="eager"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
